



































































import Vue from 'vue'
import EditorDialog from '@/components/EditorDialog.vue'
import FormDialog, { iFormDialogOptions } from '@/components/FormDialog.vue'
export default Vue.extend({
  name: 'productTypeList',
  data() {
    return {
      searchDebounce: null,
      search: '',
      selectedCampaign: '',
      selected: [],
      loadDone: false,
      productTypeOptions: null,
      productTypes: null,
      page: 1,
      perPage: 10,
      limits: [10, 20, 50, 100, 200, 500, 1000],
      total: 0,
      contentOptions: null
    }
  },
  components: {
    FormDialog,
    EditorDialog
  },
  created() {
    this.reload()
  },
  methods: {
    openContent() {
      this.contentOptions = {
        title: "Mẫu nội dung",
        content: localStorage.getItem('template-content'),
        confirmText: "Copy nội dung",
        confirmFn: async (content) => {
          navigator.clipboard.writeText(content);
          localStorage.setItem('template-content', content)
          this.$buefy.toast.open({
            message: "Đã copy",
            type: "is-info"
          });
          setTimeout(() => {
            this.contentOptions = null
          }, 100)
        }
      }
    },
    toDetails(code: string) {
      this.$router.push({ name: "productTypeDetails", params: { code } });
    },
    async reload(local = true) { 
      try {
        this.loadDone = false
        let tasks: any[] = []
        tasks.push(this.$store.dispatch('productType/getList', { local, query: { 
          limit: 0,
          order: { createdAt: -1 },
          filter: this.createFilter()
        } }).then(res => {
          this.productTypes = [...res.map((x, i) => ({...x, index: i}))]
        }))
        await Promise.all(tasks)
        this.total = this.$store.getters['productType/total']
      } catch (err) {
        this.$store.dispatch('error/handleError', err, 'Lấy danh sách thể loại thất bại')
      } finally {
        this.loadDone = true
      }
    },
    createFilter() {
      let filter = {}
      if (Object.keys(filter).length) return filter
      return undefined
    },
    createProductType(item = null) {  
      this.productTypeOptions = {
        title: "Tạo loại sản phẩm",
        confirmText: "Tạo loại sản phẩm mới",
        confirmFn: async data => {
          if (data) {
            try {
              let result = await this.$store.dispatch("productType/add", data);
              this.productTypes = [result, ...this.productTypes];
            } catch (err) {
              this.$store.dispatch(
                "error/handleError",
                err,
                "Thêm vòng quay thất bại",
                err.message
              );
            }
          }
        },
        fields: [
          {
            label: "Mã loại sản phẩm",
            property: "code",
            col: "is-6",
            required: true
          },
          {
            label: "Tên loại sản phẩm",
            property: "name",
            col: "is-6",
            required: true
          },
          {
            label: "Ghi chú",
            property: "note",
            col: "is-12",
          }
        ]
      };
    },
      async removeSelected() {
        if (!this.selected || !this.selected.length) return
        this.$buefy.dialog.confirm({
          message: 'Bạn có chắc chắn muốn xóa không?',
          onConfirm: async () => {
            try {
              this.loadDone = false
              let tasks: any[] = []
              for (let select of this.selected) {
                tasks.push(await this.$store.dispatch('productType/delete', select._id))
              }
              await Promise.all(tasks)              
              this.selected = []
              this.$buefy.toast.open({
                message: 'Xóa thành công',
                type: 'is-success'
              })
              await this.reload(false)
            } catch (err) {
              this.$store.dispatch('error/handleError', err, 'Xóa thể loại thất bại')
            }
          }
        })
      },
      searchChanged() {
        if (this.searchDebounce) clearTimeout(this.searchDebounce)
        this.searchDebounce = setTimeout(() => {
          this.filterChanged()
        }, 300)
      },
      filterChanged() {
        this.page = 1
        this.reload()
      },
      onPageChange(page) {
        this.page = page
        this.reload()
      },
  }
})
